import { render, staticRenderFns } from "./_Pinnedaccount.vue?vue&type=template&id=5da8154c&scoped=true"
import script from "./_Pinnedaccount.vue?vue&type=script&lang=js"
export * from "./_Pinnedaccount.vue?vue&type=script&lang=js"
import style0 from "./_Pinnedaccount.vue?vue&type=style&index=0&id=5da8154c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da8154c",
  null
  
)

export default component.exports